export const SEGMENTS_MAIN = [
{
    "id": "IAB1",
    "iabCode": "IAB1",
    "name": "Искусство и развлечения",
    "nameEn": "Arts & Entertainment",
    "audience": 136543959,
    "children": [
{
        "id": "IAB1-1",
        "iabCode": "IAB1-1",
        "name": "Книги и литература",
        "nameEn": "Books & Literature",
        "audience": 23414537
      },
{
        "id": "IAB1-2",
        "iabCode": "IAB1-2",
        "name": "Поклонник знаменитостей/сплетни",
        "nameEn": "Celebrity Fan/Gossip",
        "audience": 36824521
      },
{
        "id": "IAB1-3",
        "iabCode": "IAB1-3",
        "name": "Изобразительное искусство",
        "nameEn": "Fine Art",
        "audience": 3215345
      },
{
        "id": "IAB1-4",
        "iabCode": "IAB1-4",
        "name": "Юмор",
        "nameEn": "Humor",
        "audience": 10470462
      },
{
        "id": "IAB1-5",
        "iabCode": "IAB1-5",
        "name": "Фильмы",
        "nameEn": "Movies",
        "audience": 15699414
      },
{
        "id": "IAB1-6",
        "iabCode": "IAB1-6",
        "name": "Музыка",
        "nameEn": "Music",
        "audience": 19475835
      },
{
        "id": "IAB1-7",
        "iabCode": "IAB1-7",
        "name": "Телевидение",
        "nameEn": "Television",
        "audience": 27443845
      }
    ]
  },
{
    "id": "IAB2",
    "iabCode": "IAB2",
    "name": "Автомобили",
    "nameEn": "Automotive",
    "audience": 41185245,
    "children": [
{
        "id": "IAB2-1",
        "iabCode": "IAB2-1",
        "name": "Автозапчасти",
        "nameEn": "Auto Parts",
        "audience": 1254625
      },
{
        "id": "IAB2-2",
        "iabCode": "IAB2-2",
        "name": "Ремонт автомобилей",
        "nameEn": "Auto Repair",
        "audience": 3278430
      },
{
        "id": "IAB2-3",
        "iabCode": "IAB2-3",
        "name": "Покупка/продажа автомобилей",
        "nameEn": "Buying/Selling Cars",
        "audience": 4688201
      },
{
        "id": "IAB2-4",
        "iabCode": "IAB2-4",
        "name": "Культура автомобилей",
        "nameEn": "Car Culture",
        "audience": 26983
      },
{
        "id": "IAB2-5",
        "iabCode": "IAB2-5",
        "name": "Сертифицированные подержанные автомобили",
        "nameEn": "Certified Pre-Owned",
        "audience": 3158934
      },
{
        "id": "IAB2-6",
        "iabCode": "IAB2-6",
        "name": "Кабриолет",
        "nameEn": "Convertible",
        "audience": 2543
      },
{
        "id": "IAB2-7",
        "iabCode": "IAB2-7",
        "name": "Купе",
        "nameEn": "Coupe",
        "audience": 33639
      },
{
        "id": "IAB2-8",
        "iabCode": "IAB2-8",
        "name": "Кроссовер",
        "nameEn": "Crossover",
        "audience": 4967356
      },
{
        "id": "IAB2-9",
        "iabCode": "IAB2-9",
        "name": "Дизель",
        "nameEn": "Diesel",
        "audience": 1102444
      },
{
        "id": "IAB2-10",
        "iabCode": "IAB2-10",
        "name": "Электромобиль",
        "nameEn": "Electric Vehicle",
        "audience": 2866534
      },
{
        "id": "IAB2-11",
        "iabCode": "IAB2-11",
        "name": "Хэтчбек",
        "nameEn": "Hatchback",
        "audience": 710367
      },
{
        "id": "IAB2-12",
        "iabCode": "IAB2-12",
        "name": "Гибридный",
        "nameEn": "Hybrid",
        "audience": 1766305
      },
{
        "id": "IAB2-13",
        "iabCode": "IAB2-13",
        "name": "Роскошные автомобили",
        "nameEn": "Luxury",
        "audience": 1498243
      },
{
        "id": "IAB2-14",
        "iabCode": "IAB2-14",
        "name": "Минивэн",
        "nameEn": "MiniVan",
        "audience": 1634809
      },
{
        "id": "IAB2-15",
        "iabCode": "IAB2-15",
        "name": "Мотоциклы",
        "nameEn": "Mororcycles",
        "audience": 945712
      },
{
        "id": "IAB2-16",
        "iabCode": "IAB2-16",
        "name": "Внедорожники",
        "nameEn": "Off-Road Vehicles",
        "audience": 6298167
      },
{
        "id": "IAB2-17",
        "iabCode": "IAB2-17",
        "name": "Высокопроизводительные транспортные средства",
        "nameEn": "Performance Vehicles",
        "audience": 739411
      },
{
        "id": "IAB2-18",
        "iabCode": "IAB2-18",
        "name": "Пикапы",
        "nameEn": "Pickup",
        "audience": 498412
      },
{
        "id": "IAB2-19",
        "iabCode": "IAB2-19",
        "name": "Помощь на дороге",
        "nameEn": "Road-Side Assistance",
        "audience": 51633
      },
{
        "id": "IAB2-20",
        "iabCode": "IAB2-20",
        "name": "Седан",
        "nameEn": "Sedan",
        "audience": 3111627
      },
{
        "id": "IAB2-21",
        "iabCode": "IAB2-21",
        "name": "Грузовики и аксессуары",
        "nameEn": "Trucks & Accessories",
        "audience": 2198304
      },
{
        "id": "IAB2-22",
        "iabCode": "IAB2-22",
        "name": "Старинные автомобили",
        "nameEn": "Vintage Cars",
        "audience": 316888
      },
{
        "id": "IAB2-23",
        "iabCode": "IAB2-23",
        "name": "Универсал",
        "nameEn": "Wagon",
        "audience": 35678
      },
{
        "id": "IAB2-24",
        "iabCode": "IAB2-24",
        "name": "Спорткары"
      },
{
        "id": "IAB2-25",
        "iabCode": "IAB2-25",
        "name": "Автолюбители"
      },
{
        "id": "IAB2-26",
        "iabCode": "IAB2-26",
        "name": "Тюнинг автомобилей"
      },
{
        "id": "IAB2-27",
        "iabCode": "IAB2-27",
        "name": "Формула 1"
      },
{
        "id": "IAB2-28",
        "iabCode": "IAB2-28",
        "name": "Покупатели подержанных авто"
      },
{
        "id": "IAB2-29",
        "iabCode": "IAB2-29",
        "name": "Покупатели новых авто"
      },
{
        "id": "IAB2-30",
        "iabCode": "IAB2-30",
        "name": "Автолизинг"
      },
{
        "id": "IAB2-31",
        "iabCode": "IAB2-31",
        "name": "Пользователи каршеринга"
      },
{
        "id": "IAB2-32",
        "iabCode": "IAB2-32",
        "name": "Аудитория Tesla"
      },
{
        "id": "IAB2-33",
        "iabCode": "IAB2-33",
        "name": "Аудитория BMW"
      },
{
        "id": "IAB2-34",
        "iabCode": "IAB2-34",
        "name": "Аудитория Mercedes"
      },
{
        "id": "IAB2-35",
        "iabCode": "IAB2-35",
        "name": "Покупатели автомобилей"
      }
    ]
  },
{
    "id": "IAB3",
    "iabCode": "IAB3",
    "name": "Бизнес",
    "nameEn": "Business",
    "audience": 102473639,
    "children": [
{
        "id": "IAB3-1",
        "iabCode": "IAB3-1",
        "name": "Реклама",
        "nameEn": "Advertising",
        "audience": 83416988
      },
{
        "id": "IAB3-2",
        "iabCode": "IAB3-2",
        "name": "Сельское хозяйство",
        "nameEn": "Agriculture",
        "audience": 1003564
      },
{
        "id": "IAB3-3",
        "iabCode": "IAB3-3",
        "name": "Биотехнология/биомедицина",
        "nameEn": "Biotech/Biomedical",
        "audience": 946810
      },
{
        "id": "IAB3-4",
        "iabCode": "IAB3-4",
        "name": "Программное обеспечение для бизнеса",
        "nameEn": "Business Software",
        "audience": 299503
      },
{
        "id": "IAB3-5",
        "iabCode": "IAB3-5",
        "name": "Строительная промышленность",
        "nameEn": "Construction",
        "audience": 5631955
      },
{
        "id": "IAB3-6",
        "iabCode": "IAB3-6",
        "name": "Лесное хозяйство",
        "nameEn": "Forestry",
        "audience": 548
      },
{
        "id": "IAB3-7",
        "iabCode": "IAB3-7",
        "name": "Государственная поддержка",
        "nameEn": "Government",
        "audience": 1476222
      },
{
        "id": "IAB3-8",
        "iabCode": "IAB3-8",
        "name": "Экологичное решение",
        "nameEn": "Green Solutions",
        "audience": 3168
      },
{
        "id": "IAB3-9",
        "iabCode": "IAB3-9",
        "name": "Кадровые ресурсы",
        "nameEn": "Human Resources",
        "audience": 4576392
      },
{
        "id": "IAB3-10",
        "iabCode": "IAB3-10",
        "name": "Логистика",
        "nameEn": "Logistics",
        "audience": 1100482
      },
{
        "id": "IAB3-11",
        "iabCode": "IAB3-11",
        "name": "Маркетинг",
        "nameEn": "Marketing",
        "audience": 2706333
      },
{
        "id": "IAB3-12",
        "iabCode": "IAB3-12",
        "name": "Металлы",
        "nameEn": "Metals",
        "audience": 1311674
      },
{
        "id": "IAB3-13",
        "iabCode": "IAB3-13",
        "name": "Основатели стартапов"
      },
{
        "id": "IAB3-14",
        "iabCode": "IAB3-14",
        "name": "Предприниматели"
      },
{
        "id": "IAB3-15",
        "iabCode": "IAB3-15",
        "name": "Владельцы малого бизнеса"
      },
{
        "id": "IAB3-16",
        "iabCode": "IAB3-16",
        "name": "CEO"
      },
{
        "id": "IAB3-17",
        "iabCode": "IAB3-17",
        "name": "Маркетинг директора"
      },
{
        "id": "IAB3-18",
        "iabCode": "IAB3-18",
        "name": "Топ-менеджеры"
      },
{
        "id": "IAB3-19",
        "iabCode": "IAB3-19",
        "name": "HR менеджеры"
      },
{
        "id": "IAB3-20",
        "iabCode": "IAB3-20",
        "name": "IT менеджеры"
      },
{
        "id": "IAB3-21",
        "iabCode": "IAB3-21",
        "name": "Финансовые директора"
      },
{
        "id": "IAB3-22",
        "iabCode": "IAB3-22",
        "name": "Покупатели SaaS"
      },
{
        "id": "IAB3-23",
        "iabCode": "IAB3-23",
        "name": "Пользователи CRM"
      },
{
        "id": "IAB3-24",
        "iabCode": "IAB3-24",
        "name": "Пользователи ERP"
      },
{
        "id": "IAB3-25",
        "iabCode": "IAB3-25",
        "name": "Покупатели облачных сервисов"
      },
{
        "id": "IAB3-26",
        "iabCode": "IAB3-26",
        "name": "Покупатели решений по кибербезопасности"
      },
{
        "id": "IAB3-27",
        "iabCode": "IAB3-27",
        "name": "Удаленные сотрудники"
      },
{
        "id": "IAB3-28",
        "iabCode": "IAB3-28",
        "name": "Фрилансеры"
      },
{
        "id": "IAB3-29",
        "iabCode": "IAB3-29",
        "name": "Digital агентства"
      }
    ]
  },
{
    "id": "IAB4",
    "iabCode": "IAB4",
    "name": "Карьера",
    "nameEn": "Careers",
    "audience": 6479023,
    "children": [
{
        "id": "IAB4-1",
        "iabCode": "IAB4-1",
        "name": "Планирование карьеры",
        "nameEn": "Career Planning",
        "audience": 55119
      },
{
        "id": "IAB4-2",
        "iabCode": "IAB4-2",
        "name": "Институт",
        "nameEn": "College",
        "audience": 1804974
      },
{
        "id": "IAB4-3",
        "iabCode": "IAB4-3",
        "name": "Финансовая помощь",
        "nameEn": "Financial Aid",
        "audience": 903473
      },
{
        "id": "IAB4-4",
        "iabCode": "IAB4-4",
        "name": "Ярмарки вакансий",
        "nameEn": "Job Fairs",
        "audience": 374967
      },
{
        "id": "IAB4-5",
        "iabCode": "IAB4-5",
        "name": "Поиск работы",
        "nameEn": "Job Search",
        "audience": 436732
      },
{
        "id": "IAB4-6",
        "iabCode": "IAB4-6",
        "name": "Составление резюме/Консультации",
        "nameEn": "Resume Writing/Advice",
        "audience": 750273
      },
{
        "id": "IAB4-7",
        "iabCode": "IAB4-7",
        "name": "Уход",
        "nameEn": "Nursing",
        "audience": 420951
      },
{
        "id": "IAB4-8",
        "iabCode": "IAB4-8",
        "name": "Стипендии",
        "nameEn": "Scholarships",
        "audience": 602525
      },
{
        "id": "IAB4-9",
        "iabCode": "IAB4-9",
        "name": "Удаленная работа",
        "nameEn": "Telecommuting",
        "audience": 1104572
      },
{
        "id": "IAB4-11",
        "iabCode": "IAB4-11",
        "name": "Консультации по карьере",
        "nameEn": "Career Advice",
        "audience": 25437
      },
{
        "id": "IAB4-13",
        "iabCode": "IAB4-13",
        "name": "Фриланс"
      },
{
        "id": "IAB4-14",
        "iabCode": "IAB4-14",
        "name": "Gig economy"
      },
{
        "id": "IAB4-15",
        "iabCode": "IAB4-15",
        "name": "Соискатели"
      },
{
        "id": "IAB4-16",
        "iabCode": "IAB4-16",
        "name": "Пользователи LinkedIn"
      },
{
        "id": "IAB4-17",
        "iabCode": "IAB4-17",
        "name": "Онлайн сертификации"
      },
{
        "id": "IAB4-18",
        "iabCode": "IAB4-18",
        "name": "Профессиональное обучение"
      },
{
        "id": "IAB4-19",
        "iabCode": "IAB4-19",
        "name": "IT рекрутеры"
      }
    ]
  },
{
    "id": "IAB5",
    "iabCode": "IAB5",
    "name": "Образование",
    "nameEn": "Education",
    "audience": 27782355,
    "children": [
{
        "id": "IAB5-2",
        "iabCode": "IAB5-2",
        "name": "Образование для взрослых",
        "nameEn": "Adult Education",
        "audience": 4187299
      },
{
        "id": "IAB5-3",
        "iabCode": "IAB5-3",
        "name": "История искусства",
        "nameEn": "Art History",
        "audience": 850275
      },
{
        "id": "IAB5-5",
        "iabCode": "IAB5-5",
        "name": "Студенческая жизнь",
        "nameEn": "College Life",
        "audience": 1207823
      },
{
        "id": "IAB5-6",
        "iabCode": "IAB5-6",
        "name": "Дистанционное обучение",
        "nameEn": "Distance Learning",
        "audience": 2156734
      },
{
        "id": "IAB5-7",
        "iabCode": "IAB5-7",
        "name": "Английский как второй язык",
        "nameEn": "English as a 2nd Language",
        "audience": 1808335
      },
{
        "id": "IAB5-8",
        "iabCode": "IAB5-8",
        "name": "Изучение языка",
        "nameEn": "Language Learning",
        "audience": 10452561
      },
{
        "id": "IAB5-9",
        "iabCode": "IAB5-9",
        "name": "Высшая школа",
        "nameEn": "Graduate School",
        "audience": 903289
      },
{
        "id": "IAB5-10",
        "iabCode": "IAB5-10",
        "name": "Домашнее обучение",
        "nameEn": "Homeschooling",
        "audience": 1052669
      },
{
        "id": "IAB5-11",
        "iabCode": "IAB5-11",
        "name": "Советы по выполнению домашних заданий / учебе",
        "nameEn": "Homework/Study Tips",
        "audience": 750323
      },
{
        "id": "IAB5-13",
        "iabCode": "IAB5-13",
        "name": "Частная школа",
        "nameEn": "Private School",
        "audience": 1934866
      },
{
        "id": "IAB5-14",
        "iabCode": "IAB5-14",
        "name": "Специальное образование",
        "nameEn": "Special Education",
        "audience": 2176005
      },
{
        "id": "IAB5-15",
        "iabCode": "IAB5-15",
        "name": "Изучение бизнеса",
        "nameEn": "Studying Business",
        "audience": 302176
      },
{
        "id": "IAB5-16",
        "iabCode": "IAB5-16",
        "name": "Онлайн курсы"
      },
{
        "id": "IAB5-17",
        "iabCode": "IAB5-17",
        "name": "EdTech"
      },
{
        "id": "IAB5-18",
        "iabCode": "IAB5-18",
        "name": "Изучение английского"
      },
{
        "id": "IAB5-19",
        "iabCode": "IAB5-19",
        "name": "Курсы программирования"
      },
{
        "id": "IAB5-20",
        "iabCode": "IAB5-20",
        "name": "AI курсы"
      },
{
        "id": "IAB5-21",
        "iabCode": "IAB5-21",
        "name": "Data Science курсы"
      },
{
        "id": "IAB5-22",
        "iabCode": "IAB5-22",
        "name": "MBA"
      },
{
        "id": "IAB5-23",
        "iabCode": "IAB5-23",
        "name": "Coding bootcamp"
      }
    ]
  },
{
    "id": "IAB6",
    "iabCode": "IAB6",
    "name": "Семья и воспитание детей",
    "nameEn": "Family & Parenting",
    "audience": 22008169,
    "children": [
{
        "id": "IAB6-1",
        "iabCode": "IAB6-1",
        "name": "Усыновление",
        "nameEn": "Adoption",
        "audience": 35130
      },
{
        "id": "IAB6-2",
        "iabCode": "IAB6-2",
        "name": "Младенцы и малыши ясельного возраста",
        "nameEn": "Babies & Toddlers",
        "audience": 2088465
      },
{
        "id": "IAB6-3",
        "iabCode": "IAB6-3",
        "name": "Детский сад/Дошкольное учреждение",
        "nameEn": "Daycare/Pre Schoo",
        "audience": 1311783
      },
{
        "id": "IAB6-6",
        "iabCode": "IAB6-6",
        "name": "Воспитание подростков",
        "nameEn": "Parenting teens",
        "audience": 12561300
      },
{
        "id": "IAB6-7",
        "iabCode": "IAB6-7",
        "name": "Беременность",
        "nameEn": "Pregnancy",
        "audience": 4800371
      },
{
        "id": "IAB6-8",
        "iabCode": "IAB6-8",
        "name": "Дети с особенностями развития",
        "nameEn": "Special Needs Kids",
        "audience": 911485
      },
{
        "id": "IAB6-9",
        "iabCode": "IAB6-9",
        "name": "Уход за пожилыми людьми",
        "nameEn": "Eldercare",
        "audience": 299635
      },
{
        "id": "IAB6-10",
        "iabCode": "IAB6-10",
        "name": "Молодые родители"
      },
{
        "id": "IAB6-11",
        "iabCode": "IAB6-11",
        "name": "Детские товары"
      },
{
        "id": "IAB6-12",
        "iabCode": "IAB6-12",
        "name": "Семейные путешествия"
      },
{
        "id": "IAB6-13",
        "iabCode": "IAB6-13",
        "name": "Детское образование"
      }
    ]
  },
{
    "id": "IAB7",
    "iabCode": "IAB7",
    "name": "Здоровье и фитнес",
    "nameEn": "Health & Fitness",
    "audience": 24239730,
    "children": [
{
        "id": "IAB7-1",
        "iabCode": "IAB7-1",
        "name": "Зарядка",
        "nameEn": "Exercise",
        "audience": 150732
      },
{
        "id": "IAB7-4",
        "iabCode": "IAB7-4",
        "name": "Аллергии",
        "nameEn": "Allergies",
        "audience": 347208
      },
{
        "id": "IAB7-9",
        "iabCode": "IAB7-9",
        "name": "Биполярное расстройство",
        "nameEn": "Bipolar Disorder",
        "audience": 61398
      },
{
        "id": "IAB7-13",
        "iabCode": "IAB7-13",
        "name": "Синдром хронической усталости",
        "nameEn": "Chronic Fatigue Syndrome",
        "audience": 402548
      },
{
        "id": "IAB7-14",
        "iabCode": "IAB7-14",
        "name": "Хроническая боль",
        "nameEn": "Chronic Pain",
        "audience": 381792
      },
{
        "id": "IAB7-15",
        "iabCode": "IAB7-15",
        "name": "Простуда и грипп",
        "nameEn": "Cold & Flu",
        "audience": 1109485
      },
{
        "id": "IAB7-17",
        "iabCode": "IAB7-17",
        "name": "Уход за зубами",
        "nameEn": "Dental Care",
        "audience": 4219904
      },
{
        "id": "IAB7-18",
        "iabCode": "IAB7-18",
        "name": "Депрессия",
        "nameEn": "Depression",
        "audience": 1100632
      },
{
        "id": "IAB7-19",
        "iabCode": "IAB7-19",
        "name": "Дерматология",
        "nameEn": "Dermatology",
        "audience": 1455370
      },
{
        "id": "IAB7-20",
        "iabCode": "IAB7-20",
        "name": "Диабет",
        "nameEn": "Diabetes",
        "audience": 5409376
      },
{
        "id": "IAB7-21",
        "iabCode": "IAB7-21",
        "name": "Эпилепсия",
        "nameEn": "Epilepsy",
        "audience": 2067331
      },
{
        "id": "IAB7-23",
        "iabCode": "IAB7-23",
        "name": "Головные боли/мигрень",
        "nameEn": "Headaches/Migraines",
        "audience": 102587
      },
{
        "id": "IAB7-24",
        "iabCode": "IAB7-24",
        "name": "Болезни сердца",
        "nameEn": "Heart Disease",
        "audience": 950729
      },
{
        "id": "IAB7-30",
        "iabCode": "IAB7-30",
        "name": "Бесплодие",
        "nameEn": "Infertility",
        "audience": 25021
      },
{
        "id": "IAB7-31",
        "iabCode": "IAB7-31",
        "name": "Мужское здоровье",
        "nameEn": "Men's Health",
        "audience": 199527
      },
{
        "id": "IAB7-32",
        "iabCode": "IAB7-32",
        "name": "Питание",
        "nameEn": "Nutrition",
        "audience": 62516
      },
{
        "id": "IAB7-33",
        "iabCode": "IAB7-33",
        "name": "Ортопедия",
        "nameEn": "Orthopedics",
        "audience": 200791
      },
{
        "id": "IAB7-34",
        "iabCode": "IAB7-34",
        "name": "Панические/Тревожные расстройства",
        "nameEn": "Panic/Anxiety Disorders",
        "audience": 287091
      },
{
        "id": "IAB7-35",
        "iabCode": "IAB7-35",
        "name": "Педиатрия",
        "nameEn": "Pediatrics",
        "audience": 248610
      },
{
        "id": "IAB7-36",
        "iabCode": "IAB7-36",
        "name": "Физическая терапия",
        "nameEn": "Physical Therapy",
        "audience": 603851
      },
{
        "id": "IAB7-37",
        "iabCode": "IAB7-37",
        "name": "Психология/психиатрия",
        "nameEn": "Psychology/Psychiatry",
        "audience": 598326
      },
{
        "id": "IAB7-38",
        "iabCode": "IAB7-38",
        "name": "Здоровье пенсионеров",
        "nameEn": "Senor Health",
        "audience": 149927
      },
{
        "id": "IAB7-39",
        "iabCode": "IAB7-39",
        "name": "Сексуальное здоровье",
        "nameEn": "Sexuality",
        "audience": 908326
      },
{
        "id": "IAB7-40",
        "iabCode": "IAB7-40",
        "name": "Расстройства сна",
        "nameEn": "Sleep Disorders",
        "audience": 703942
      },
{
        "id": "IAB7-41",
        "iabCode": "IAB7-41",
        "name": "Отказ от курения",
        "nameEn": "Smoking Cessation",
        "audience": 410884
      },
{
        "id": "IAB7-43",
        "iabCode": "IAB7-43",
        "name": "Заболевания щитовидной железы",
        "nameEn": "Thyroid Disease",
        "audience": 321784
      },
{
        "id": "IAB7-44",
        "iabCode": "IAB7-44",
        "name": "Потеря веса",
        "nameEn": "Weight Loss",
        "audience": 342005
      },
{
        "id": "IAB7-45",
        "iabCode": "IAB7-45",
        "name": "Женское здоровье",
        "nameEn": "Women's Health",
        "audience": 1418037
      },
{
        "id": "IAB7-46",
        "iabCode": "IAB7-46",
        "name": "Фитнес"
      },
{
        "id": "IAB7-47",
        "iabCode": "IAB7-47",
        "name": "Велосипеды"
      },
{
        "id": "IAB7-48",
        "iabCode": "IAB7-48",
        "name": "Горные велосипеды"
      },
{
        "id": "IAB7-49",
        "iabCode": "IAB7-49",
        "name": "Электровелосипеды"
      },
{
        "id": "IAB7-50",
        "iabCode": "IAB7-50",
        "name": "Самокаты"
      },
{
        "id": "IAB7-51",
        "iabCode": "IAB7-51",
        "name": "Электросамокаты"
      },
{
        "id": "IAB7-52",
        "iabCode": "IAB7-52",
        "name": "Беговые кроссовки"
      },
{
        "id": "IAB7-53",
        "iabCode": "IAB7-53",
        "name": "Фитнес-оборудование"
      },
{
        "id": "IAB7-54",
        "iabCode": "IAB7-54",
        "name": "Витамины"
      },
{
        "id": "IAB7-55",
        "iabCode": "IAB7-55",
        "name": "Аминокислоты"
      },
{
        "id": "IAB7-56",
        "iabCode": "IAB7-56",
        "name": "Йога-товары"
      },
{
        "id": "IAB7-57",
        "iabCode": "IAB7-57",
        "name": "Товары для туризма"
      },
{
        "id": "IAB7-58",
        "iabCode": "IAB7-58",
        "name": "Палатки"
      },
{
        "id": "IAB7-59",
        "iabCode": "IAB7-59",
        "name": "Спальные мешки"
      },
{
        "id": "IAB7-60",
        "iabCode": "IAB7-60",
        "name": "Домашние тренажеры"
      },
{
        "id": "IAB7-61",
        "iabCode": "IAB7-61",
        "name": "Гантели"
      },
{
        "id": "IAB7-62",
        "iabCode": "IAB7-62",
        "name": "Штанги"
      },
{
        "id": "IAB7-63",
        "iabCode": "IAB7-63",
        "name": "Кардиотренажеры"
      },
{
        "id": "IAB7-64",
        "iabCode": "IAB7-64",
        "name": "Умные тренажеры"
      },
{
        "id": "IAB7-65",
        "iabCode": "IAB7-65",
        "name": "Спортивное питание"
      },
{
        "id": "IAB7-66",
        "iabCode": "IAB7-66",
        "name": "Протеин"
      },
{
        "id": "IAB7-67",
        "iabCode": "IAB7-67",
        "name": "Медитация"
      },
{
        "id": "IAB7-68",
        "iabCode": "IAB7-68",
        "name": "Психическое здоровье"
      },
{
        "id": "IAB7-69",
        "iabCode": "IAB7-69",
        "name": "Трекинг сна"
      },
{
        "id": "IAB7-70",
        "iabCode": "IAB7-70",
        "name": "Биохакинг"
      }
    ]
  },
{
    "id": "IAB8",
    "iabCode": "IAB8",
    "name": "Еда и напитки",
    "nameEn": "Food & Drink",
    "audience": 12172788,
    "children": [
{
        "id": "IAB8-2",
        "iabCode": "IAB8-2",
        "name": "Барбекю и гриль",
        "nameEn": "Barbecues & Grilling",
        "audience": 1199528
      },
{
        "id": "IAB8-4",
        "iabCode": "IAB8-4",
        "name": "Китайская кухня",
        "nameEn": "Chinese Cuisine",
        "audience": 906872
      },
{
        "id": "IAB8-5",
        "iabCode": "IAB8-5",
        "name": "Коктейли/Пиво",
        "nameEn": "Cocktails/Beer",
        "audience": 703782
      },
{
        "id": "IAB8-6",
        "iabCode": "IAB8-6",
        "name": "Кофе/Чай",
        "nameEn": "Coffee/Tea",
        "audience": 610877
      },
{
        "id": "IAB8-7",
        "iabCode": "IAB8-7",
        "name": "Специфическая кухня",
        "nameEn": "Cuisine-Specific",
        "audience": 1104503
      },
{
        "id": "IAB8-8",
        "iabCode": "IAB8-8",
        "name": "Десерты и выпечка",
        "nameEn": "Desserts & Baking",
        "audience": 1506843
      },
{
        "id": "IAB8-9",
        "iabCode": "IAB8-9",
        "name": "Ужины вне дома",
        "nameEn": "Dining Out",
        "audience": 150563
      },
{
        "id": "IAB8-10",
        "iabCode": "IAB8-10",
        "name": "Пищевые аллергии",
        "nameEn": "Food Allergies",
        "audience": 122790
      },
{
        "id": "IAB8-11",
        "iabCode": "IAB8-11",
        "name": "Французская кухня",
        "nameEn": "French Cuisine",
        "audience": 1000024
      },
{
        "id": "IAB8-12",
        "iabCode": "IAB8-12",
        "name": "Приготовление здоровой пищи / с низким содержанием жира",
        "nameEn": "Health/Lowfat Cooking",
        "audience": 1300678
      },
{
        "id": "IAB8-13",
        "iabCode": "IAB8-13",
        "name": "Итальянская кухня",
        "nameEn": "Italian Cuisine",
        "audience": 1067309
      },
{
        "id": "IAB8-14",
        "iabCode": "IAB8-14",
        "name": "Японская кухня",
        "nameEn": "Japanese Cuisine",
        "audience": 843671
      },
{
        "id": "IAB8-15",
        "iabCode": "IAB8-15",
        "name": "Мексиканская кухня",
        "nameEn": "Mexican Cuisine",
        "audience": 999562
      },
{
        "id": "IAB8-16",
        "iabCode": "IAB8-16",
        "name": "Веган",
        "nameEn": "Vegan",
        "audience": 19429
      },
{
        "id": "IAB8-17",
        "iabCode": "IAB8-17",
        "name": "Вегетарианец",
        "nameEn": "Vegetarian",
        "audience": 37621
      },
{
        "id": "IAB8-18",
        "iabCode": "IAB8-18",
        "name": "Вино",
        "nameEn": "Wine",
        "audience": 598736
      },
{
        "id": "IAB8-19",
        "iabCode": "IAB8-19",
        "name": "Доставка продуктов"
      },
{
        "id": "IAB8-20",
        "iabCode": "IAB8-20",
        "name": "Органические продукты"
      },
{
        "id": "IAB8-21",
        "iabCode": "IAB8-21",
        "name": "Фермерские продукты"
      },
{
        "id": "IAB8-22",
        "iabCode": "IAB8-22",
        "name": "Кофе"
      },
{
        "id": "IAB8-23",
        "iabCode": "IAB8-23",
        "name": "Чай"
      },
{
        "id": "IAB8-25",
        "iabCode": "IAB8-25",
        "name": "Сыры"
      },
{
        "id": "IAB8-26",
        "iabCode": "IAB8-26",
        "name": "Мясо"
      },
{
        "id": "IAB8-27",
        "iabCode": "IAB8-27",
        "name": "Морепродукты"
      },
{
        "id": "IAB8-28",
        "iabCode": "IAB8-28",
        "name": "Здоровое питание"
      },
{
        "id": "IAB8-29",
        "iabCode": "IAB8-29",
        "name": "Веганские продукты"
      },
{
        "id": "IAB8-30",
        "iabCode": "IAB8-30",
        "name": "Keto-продукты"
      },
{
        "id": "IAB8-31",
        "iabCode": "IAB8-31",
        "name": "Безглютеновые продукты"
      },
{
        "id": "IAB8-32",
        "iabCode": "IAB8-32",
        "name": "Детское питание"
      },
{
        "id": "IAB8-33",
        "iabCode": "IAB8-33",
        "name": "Готовая еда"
      },
{
        "id": "IAB8-34",
        "iabCode": "IAB8-34",
        "name": "Замороженные продукты"
      },
{
        "id": "IAB8-35",
        "iabCode": "IAB8-35",
        "name": "Снеки"
      },
{
        "id": "IAB8-36",
        "iabCode": "IAB8-36",
        "name": "Сладости"
      },
{
        "id": "IAB8-37",
        "iabCode": "IAB8-37",
        "name": "Пользователи доставки еды"
      },
{
        "id": "IAB8-38",
        "iabCode": "IAB8-38",
        "name": "Посетители ресторанов"
      },
{
        "id": "IAB8-41",
        "iabCode": "IAB8-41",
        "name": "Любители кофе"
      },
{
        "id": "IAB8-42",
        "iabCode": "IAB8-42",
        "name": "Крафтовое пиво"
      },
{
        "id": "IAB8-43",
        "iabCode": "IAB8-43",
        "name": "Кето диета"
      }
    ]
  },
{
    "id": "IAB9",
    "iabCode": "IAB9",
    "name": "Хобби и интересы",
    "nameEn": "Hobbies & Interests",
    "audience": 15751836,
    "children": [
{
        "id": "IAB9-1",
        "iabCode": "IAB9-1",
        "name": "Искусство/технологии",
        "nameEn": "Art/Technology",
        "audience": 350792
      },
{
        "id": "IAB9-2",
        "iabCode": "IAB9-2",
        "name": "Искусство и ремесла",
        "nameEn": "Arts & Crafts",
        "audience": 354760
      },
{
        "id": "IAB9-3",
        "iabCode": "IAB9-3",
        "name": "Бисероплетение",
        "nameEn": "Beadwork",
        "audience": 183094
      },
{
        "id": "IAB9-4",
        "iabCode": "IAB9-4",
        "name": "Наблюдение за птицами",
        "nameEn": "Birdwatching",
        "audience": 2178
      },
{
        "id": "IAB9-5",
        "iabCode": "IAB9-5",
        "name": "Настольные игры/пазлы",
        "nameEn": "Board Games/Puzzles",
        "audience": 209633
      },
{
        "id": "IAB9-6",
        "iabCode": "IAB9-6",
        "name": "Изготовление свечей и мыла",
        "nameEn": "Candle & Soap Making",
        "audience": 126892
      },
{
        "id": "IAB9-7",
        "iabCode": "IAB9-7",
        "name": "Карточные игры",
        "nameEn": "Card Games",
        "audience": 220618
      },
{
        "id": "IAB9-8",
        "iabCode": "IAB9-8",
        "name": "Шахматы",
        "nameEn": "Chess",
        "audience": 151783
      },
{
        "id": "IAB9-9",
        "iabCode": "IAB9-9",
        "name": "Сигары",
        "nameEn": "Cigars",
        "audience": 501375
      },
{
        "id": "IAB9-10",
        "iabCode": "IAB9-10",
        "name": "Коллекционирование",
        "nameEn": "Collecting",
        "audience": 370259
      },
{
        "id": "IAB9-11",
        "iabCode": "IAB9-11",
        "name": "Комиксы",
        "nameEn": "Comic Books",
        "audience": 40813
      },
{
        "id": "IAB9-12",
        "iabCode": "IAB9-12",
        "name": "Рисование/зарисовка эскизов",
        "nameEn": "Drawing/Sketching",
        "audience": 221583
      },
{
        "id": "IAB9-13",
        "iabCode": "IAB9-13",
        "name": "Внештатный писатель",
        "nameEn": "Freelance Writing",
        "audience": 299643
      },
{
        "id": "IAB9-15",
        "iabCode": "IAB9-15",
        "name": "Упоминания в СМИ",
        "nameEn": "Getting Published",
        "audience": 248943
      },
{
        "id": "IAB9-16",
        "iabCode": "IAB9-16",
        "name": "Гитара",
        "nameEn": "Guitar",
        "audience": 695270
      },
{
        "id": "IAB9-17",
        "iabCode": "IAB9-17",
        "name": "Домашняя запись",
        "nameEn": "Home Recording",
        "audience": 183953
      },
{
        "id": "IAB9-18",
        "iabCode": "IAB9-18",
        "name": "Инвесторы и патенты",
        "nameEn": "Investors & Patents",
        "audience": 99604
      },
{
        "id": "IAB9-19",
        "iabCode": "IAB9-19",
        "name": "Изготовление ювелирных изделий",
        "nameEn": "Jewelry Making",
        "audience": 2401588
      },
{
        "id": "IAB9-20",
        "iabCode": "IAB9-20",
        "name": "Магия и иллюзия",
        "nameEn": "Magic & Illusion",
        "audience": 403761
      },
{
        "id": "IAB9-21",
        "iabCode": "IAB9-21",
        "name": "Рукоделие",
        "nameEn": "Needlework",
        "audience": 1004289
      },
{
        "id": "IAB9-22",
        "iabCode": "IAB9-22",
        "name": "Живопись",
        "nameEn": "Painting",
        "audience": 404762
      },
{
        "id": "IAB9-23",
        "iabCode": "IAB9-23",
        "name": "Фотография",
        "nameEn": "Photography",
        "audience": 1222417
      },
{
        "id": "IAB9-24",
        "iabCode": "IAB9-24",
        "name": "Радио",
        "nameEn": "Radio",
        "audience": 265711
      },
{
        "id": "IAB9-25",
        "iabCode": "IAB9-25",
        "name": "Ролевые игры",
        "nameEn": "Roleplaying Games",
        "audience": 220563
      },
{
        "id": "IAB9-26",
        "iabCode": "IAB9-26",
        "name": "Научная фантастика и фэнтези",
        "nameEn": "Sci-Fi & Fantasy",
        "audience": 601006
      },
{
        "id": "IAB9-28",
        "iabCode": "IAB9-28",
        "name": "Написание сценариев",
        "nameEn": "Screenwriting",
        "audience": 201587
      },
{
        "id": "IAB9-29",
        "iabCode": "IAB9-29",
        "name": "Марки и монеты",
        "nameEn": "Stamps & Coins",
        "audience": 247830
      },
{
        "id": "IAB9-30",
        "iabCode": "IAB9-30",
        "name": "Видео игры и компьютерные игры",
        "nameEn": "Video & Computer Games",
        "audience": 2109673
      },
{
        "id": "IAB9-31",
        "iabCode": "IAB9-31",
        "name": "Резьба по дереву",
        "nameEn": "Woodworking",
        "audience": 2407456
      },
{
        "id": "IAB9-32",
        "iabCode": "IAB9-32",
        "name": "Видеосъемка"
      },
{
        "id": "IAB9-33",
        "iabCode": "IAB9-33",
        "name": "Подкасты"
      },
{
        "id": "IAB9-34",
        "iabCode": "IAB9-34",
        "name": "Музыкальное продюсирование"
      },
{
        "id": "IAB9-35",
        "iabCode": "IAB9-35",
        "name": "Графический дизайн"
      },
{
        "id": "IAB9-36",
        "iabCode": "IAB9-36",
        "name": "3D моделирование"
      },
{
        "id": "IAB9-37",
        "iabCode": "IAB9-37",
        "name": "DIY"
      },
{
        "id": "IAB9-38",
        "iabCode": "IAB9-38",
        "name": "Крипто майнинг"
      },
{
        "id": "IAB9-39",
        "iabCode": "IAB9-39",
        "name": "Любители дронов"
      }
    ]
  },
{
    "id": "IAB10",
    "iabCode": "IAB10",
    "name": "Дом и сад",
    "nameEn": "Home & Garden",
    "audience": 10348012,
    "children": [
{
        "id": "IAB10-1",
        "iabCode": "IAB10-1",
        "name": "Техника",
        "nameEn": "Appliances",
        "audience": 760227
      },
{
        "id": "IAB10-2",
        "iabCode": "IAB10-2",
        "name": "Развлечения",
        "nameEn": "Entertaining",
        "audience": 1100000
      },
{
        "id": "IAB10-3",
        "iabCode": "IAB10-3",
        "name": "Экологическая безопасность",
        "nameEn": "Environmental Safety",
        "audience": 407335
      },
{
        "id": "IAB10-4",
        "iabCode": "IAB10-4",
        "name": "Садоводство",
        "nameEn": "Gardening",
        "audience": 3603775
      },
{
        "id": "IAB10-5",
        "iabCode": "IAB10-5",
        "name": "Ремонт дома",
        "nameEn": "Home Repair",
        "audience": 599430
      },
{
        "id": "IAB10-6",
        "iabCode": "IAB10-6",
        "name": "Домашний кинотеатр",
        "nameEn": "Home Theater",
        "audience": 501783
      },
{
        "id": "IAB10-7",
        "iabCode": "IAB10-7",
        "name": "Декорирование интерьера",
        "nameEn": "Interior Decorating",
        "audience": 866329
      },
{
        "id": "IAB10-8",
        "iabCode": "IAB10-8",
        "name": "Озеленение",
        "nameEn": "Landscaping",
        "audience": 93471
      },
{
        "id": "IAB10-9",
        "iabCode": "IAB10-9",
        "name": "Строительство и ремонт",
        "nameEn": "Remodeling & Construction",
        "audience": 2415662
      }
    ]
  },
{
    "id": "IAB11",
    "iabCode": "IAB11",
    "name": "Юриспруденция, правительство и политика",
    "nameEn": "Law, Gov't & Politics",
    "audience": 5074163,
    "children": [
{
        "id": "IAB11-1",
        "iabCode": "IAB11-1",
        "name": "Иммиграция",
        "nameEn": "Immigration",
        "audience": 800578
      },
{
        "id": "IAB11-2",
        "iabCode": "IAB11-2",
        "name": "Юридические вопросы",
        "nameEn": "Legal Issues",
        "audience": 1205833
      },
{
        "id": "IAB11-3",
        "iabCode": "IAB11-3",
        "name": "Политика",
        "nameEn": "Politics",
        "audience": 900659
      },
{
        "id": "IAB11-5",
        "iabCode": "IAB11-5",
        "name": "Комментарий",
        "nameEn": "Commentary",
        "audience": 2167093
      }
    ]
  },
{
    "id": "IAB12",
    "iabCode": "IAB12",
    "name": "Новости",
    "nameEn": "News",
    "audience": 25592368,
    "children": [
{
        "id": "IAB12-1",
        "iabCode": "IAB12-1",
        "name": "Международные новости",
        "nameEn": "International News",
        "audience": 8205728
      },
{
        "id": "IAB12-2",
        "iabCode": "IAB12-2",
        "name": "Национальные новости",
        "nameEn": "National News",
        "audience": 10583219
      },
{
        "id": "IAB12-3",
        "iabCode": "IAB12-3",
        "name": "Местные новости",
        "nameEn": "Local News",
        "audience": 6803421
      }
    ]
  },
{
    "id": "IAB13",
    "iabCode": "IAB13",
    "name": "Личные финансы",
    "nameEn": "Personal Finance",
    "audience": 10879456,
    "children": [
{
        "id": "IAB13-1",
        "iabCode": "IAB13-1",
        "name": "Начало инвестирования",
        "nameEn": "Beginning Investing",
        "audience": 804386
      },
{
        "id": "IAB13-2",
        "iabCode": "IAB13-2",
        "name": "Кредит/Задолженность и займы",
        "nameEn": "Credit/Debt & Loans",
        "audience": 1300982
      },
{
        "id": "IAB13-3",
        "iabCode": "IAB13-3",
        "name": "Финансовые новости",
        "nameEn": "Financial News",
        "audience": 906773
      },
{
        "id": "IAB13-4",
        "iabCode": "IAB13-4",
        "name": "Финансовое планирование",
        "nameEn": "Financial Planning",
        "audience": 1105687
      },
{
        "id": "IAB13-6",
        "iabCode": "IAB13-6",
        "name": "Страхование",
        "nameEn": "Insurance",
        "audience": 1100451
      },
{
        "id": "IAB13-7",
        "iabCode": "IAB13-7",
        "name": "Инвестиции",
        "nameEn": "Investing",
        "audience": 1177390
      },
{
        "id": "IAB13-8",
        "iabCode": "IAB13-8",
        "name": "Взаимные фонды",
        "nameEn": "Mutual Funds",
        "audience": 605891
      },
{
        "id": "IAB13-9",
        "iabCode": "IAB13-9",
        "name": "Опции",
        "nameEn": "Options",
        "audience": 306998
      },
{
        "id": "IAB13-10",
        "iabCode": "IAB13-10",
        "name": "Планирование выхода на пенсию",
        "nameEn": "Retirement Planning",
        "audience": 1604289
      },
{
        "id": "IAB13-11",
        "iabCode": "IAB13-11",
        "name": "Запасы",
        "nameEn": "Stocks",
        "audience": 1010369
      },
{
        "id": "IAB13-12",
        "iabCode": "IAB13-12",
        "name": "Налоговое планирование",
        "nameEn": "Tax Planning",
        "audience": 956240
      },
{
        "id": "IAB13-5",
        "iabCode": "IAB13-5",
        "name": "Автокредиты"
      },
{
        "id": "IAB13-13",
        "iabCode": "IAB13-13",
        "name": "Вклады"
      },
{
        "id": "IAB13-14",
        "iabCode": "IAB13-14",
        "name": "Рефинансирование"
      },
{
        "id": "IAB13-15",
        "iabCode": "IAB13-15",
        "name": "Микрозаймы"
      },
{
        "id": "IAB13-16",
        "iabCode": "IAB13-16",
        "name": "BNPL-сервисы"
      },
{
        "id": "IAB13-17",
        "iabCode": "IAB13-17",
        "name": "Пенсионные продукты"
      },
{
        "id": "IAB13-18",
        "iabCode": "IAB13-18",
        "name": "Кредитные карты"
      },
{
        "id": "IAB13-19",
        "iabCode": "IAB13-19",
        "name": "Ипотека"
      },
{
        "id": "IAB13-20",
        "iabCode": "IAB13-20",
        "name": "Потребительские кредиты"
      },
{
        "id": "IAB13-21",
        "iabCode": "IAB13-21",
        "name": "Инвестиционные продукты"
      },
{
        "id": "IAB13-22",
        "iabCode": "IAB13-22",
        "name": "Брокерские счета"
      },
{
        "id": "IAB13-23",
        "iabCode": "IAB13-23",
        "name": "Криптовалюты"
      },
{
        "id": "IAB13-24",
        "iabCode": "IAB13-24",
        "name": "Накопительные счета"
      },
{
        "id": "IAB13-25",
        "iabCode": "IAB13-25",
        "name": "Дебетовые карты"
      }
    ]
  },
{
    "id": "IAB14",
    "iabCode": "IAB14",
    "name": "Общество",
    "nameEn": "Society",
    "audience": 75169998,
    "children": [
{
        "id": "IAB14-1",
        "iabCode": "IAB14-1",
        "name": "Знакомства",
        "nameEn": "Dating",
        "audience": 65329671
      },
{
        "id": "IAB14-2",
        "iabCode": "IAB14-2",
        "name": "Поддержка при разводе",
        "nameEn": "Divorce Support",
        "audience": 1805839
      },
{
        "id": "IAB14-3",
        "iabCode": "IAB14-3",
        "name": "Веселая жизнь",
        "nameEn": "Gay Life",
        "audience": 904521
      },
{
        "id": "IAB14-4",
        "iabCode": "IAB14-4",
        "name": "Брак",
        "nameEn": "Marriage",
        "audience": 1503672
      },
{
        "id": "IAB14-5",
        "iabCode": "IAB14-5",
        "name": "Жизнь для пожилых людей",
        "nameEn": "Senior Living",
        "audience": 1099482
      },
{
        "id": "IAB14-6",
        "iabCode": "IAB14-6",
        "name": "Подростки",
        "nameEn": "Teens",
        "audience": 3217539
      },
{
        "id": "IAB14-7",
        "iabCode": "IAB14-7",
        "name": "Свадьбы",
        "nameEn": "Weddings",
        "audience": 1309274
      }
    ]
  },
{
    "id": "IAB15",
    "iabCode": "IAB15",
    "name": "Наука",
    "nameEn": "Science",
    "audience": 3738244,
    "children": [
{
        "id": "IAB15-1",
        "iabCode": "IAB15-1",
        "name": "Астрология",
        "nameEn": "Astrology",
        "audience": 398651
      },
{
        "id": "IAB15-2",
        "iabCode": "IAB15-2",
        "name": "Биология",
        "nameEn": "Biology",
        "audience": 612555
      },
{
        "id": "IAB15-3",
        "iabCode": "IAB15-3",
        "name": "Химия",
        "nameEn": "Chemistry",
        "audience": 305782
      },
{
        "id": "IAB15-4",
        "iabCode": "IAB15-4",
        "name": "Геология",
        "nameEn": "Geology",
        "audience": 250387
      },
{
        "id": "IAB15-6",
        "iabCode": "IAB15-6",
        "name": "Физика",
        "nameEn": "Physics",
        "audience": 351782
      },
{
        "id": "IAB15-7",
        "iabCode": "IAB15-7",
        "name": "Космос/астрономия",
        "nameEn": "Space/Astronomy",
        "audience": 505812
      },
{
        "id": "IAB15-8",
        "iabCode": "IAB15-8",
        "name": "География",
        "nameEn": "Geography",
        "audience": 279973
      },
{
        "id": "IAB15-9",
        "iabCode": "IAB15-9",
        "name": "Ботаника",
        "nameEn": "Botany",
        "audience": 323874
      },
{
        "id": "IAB15-10",
        "iabCode": "IAB15-10",
        "name": "Погода",
        "nameEn": "Weather",
        "audience": 709428
      }
    ]
  },
{
    "id": "IAB16",
    "iabCode": "IAB16",
    "name": "Домашние животные",
    "nameEn": "Pets",
    "audience": 14454273,
    "children": [
{
        "id": "IAB16-1",
        "iabCode": "IAB16-1",
        "name": "Рыбы и аквариумы",
        "nameEn": "Aquariums",
        "audience": 1896003
      },
{
        "id": "IAB16-2",
        "iabCode": "IAB16-2",
        "name": "Птицы",
        "nameEn": "Birds",
        "audience": 905228
      },
{
        "id": "IAB16-3",
        "iabCode": "IAB16-3",
        "name": "Кошки",
        "nameEn": "Cats",
        "audience": 4208833
      },
{
        "id": "IAB16-4",
        "iabCode": "IAB16-4",
        "name": "Собаки",
        "nameEn": "Dogs",
        "audience": 5140320
      },
{
        "id": "IAB16-5",
        "iabCode": "IAB16-5",
        "name": "Крупные животные",
        "nameEn": "Large Animals",
        "audience": 798425
      },
{
        "id": "IAB16-6",
        "iabCode": "IAB16-6",
        "name": "Рептилии",
        "nameEn": "Reptiles",
        "audience": 401866
      },
{
        "id": "IAB16-7",
        "iabCode": "IAB16-7",
        "name": "Ветеринарная медицина",
        "nameEn": "Veterinary Medicine",
        "audience": 1103598
      },
{
        "id": "IAB16-8",
        "iabCode": "IAB16-8",
        "name": "Аквариумы"
      },
{
        "id": "IAB16-9",
        "iabCode": "IAB16-9",
        "name": "Товары для птиц"
      },
{
        "id": "IAB16-10",
        "iabCode": "IAB16-10",
        "name": "Товары для грызунов"
      },
{
        "id": "IAB16-11",
        "iabCode": "IAB16-11",
        "name": "Товары для рептилий"
      },
{
        "id": "IAB16-12",
        "iabCode": "IAB16-12",
        "name": "Корма для собак"
      },
{
        "id": "IAB16-13",
        "iabCode": "IAB16-13",
        "name": "Корма для кошек"
      },
{
        "id": "IAB16-14",
        "iabCode": "IAB16-14",
        "name": "Ветеринарные препараты"
      },
{
        "id": "IAB16-15",
        "iabCode": "IAB16-15",
        "name": "Игрушки для животных"
      },
{
        "id": "IAB16-16",
        "iabCode": "IAB16-16",
        "name": "Лежанки"
      },
{
        "id": "IAB16-17",
        "iabCode": "IAB16-17",
        "name": "Наполнители"
      }
    ]
  },
{
    "id": "IAB17",
    "iabCode": "IAB17",
    "name": "Спорт",
    "nameEn": "Sports",
    "audience": 47011290,
    "children": [
{
        "id": "IAB17-1",
        "iabCode": "IAB17-1",
        "name": "Автогонки",
        "nameEn": "Auto Racing",
        "audience": 1435670
      },
{
        "id": "IAB17-2",
        "iabCode": "IAB17-2",
        "name": "Бейсбол",
        "nameEn": "Baseball",
        "audience": 3201599
      },
{
        "id": "IAB17-3",
        "iabCode": "IAB17-3",
        "name": "Езда на велосипеде",
        "nameEn": "Bicycling",
        "audience": 2800772
      },
{
        "id": "IAB17-4",
        "iabCode": "IAB17-4",
        "name": "Бодибилдинг",
        "nameEn": "Bodybuilding",
        "audience": 1100468
      },
{
        "id": "IAB17-5",
        "iabCode": "IAB17-5",
        "name": "Бокс",
        "nameEn": "Boxing",
        "audience": 899542
      },
{
        "id": "IAB17-6",
        "iabCode": "IAB17-6",
        "name": "Гребля на каноэ/байдарках",
        "nameEn": "Canoeing/Kayaking",
        "audience": 601379
      },
{
        "id": "IAB17-7",
        "iabCode": "IAB17-7",
        "name": "Черлидинг",
        "nameEn": "Cheerleading",
        "audience": 604604
      },
{
        "id": "IAB17-8",
        "iabCode": "IAB17-8",
        "name": "Скалолазание",
        "nameEn": "Climbing",
        "audience": 511093
      },
{
        "id": "IAB17-9",
        "iabCode": "IAB17-9",
        "name": "Крикет",
        "nameEn": "Cricket",
        "audience": 405872
      },
{
        "id": "IAB17-10",
        "iabCode": "IAB17-10",
        "name": "Фигурное катание",
        "nameEn": "Figure Skating",
        "audience": 358003
      },
{
        "id": "IAB17-11",
        "iabCode": "IAB17-11",
        "name": "Ловля рыбы нахлыстом",
        "nameEn": "Fly Fishing",
        "audience": 708420
      },
{
        "id": "IAB17-12",
        "iabCode": "IAB17-12",
        "name": "футбол",
        "nameEn": "Football",
        "audience": 2999005
      },
{
        "id": "IAB17-13",
        "iabCode": "IAB17-13",
        "name": "Пресноводная рыбалка",
        "nameEn": "Freshwater Fishing",
        "audience": 1204883
      },
{
        "id": "IAB17-14",
        "iabCode": "IAB17-14",
        "name": "Дичь и рыба",
        "nameEn": "Game & Fish",
        "audience": 674782
      },
{
        "id": "IAB17-15",
        "iabCode": "IAB17-15",
        "name": "Гольф",
        "nameEn": "Golf",
        "audience": 2109488
      },
{
        "id": "IAB17-16",
        "iabCode": "IAB17-16",
        "name": "Скачки",
        "nameEn": "Horse Racing",
        "audience": 1000432
      },
{
        "id": "IAB17-17",
        "iabCode": "IAB17-17",
        "name": "Лошади",
        "nameEn": "Horses",
        "audience": 1600481
      },
{
        "id": "IAB17-18",
        "iabCode": "IAB17-18",
        "name": "Охота/Стрельба",
        "nameEn": "Hunting/Shooting",
        "audience": 1400577
      },
{
        "id": "IAB17-19",
        "iabCode": "IAB17-19",
        "name": "Роликовые коньки",
        "nameEn": "Inline Skating",
        "audience": 598301
      },
{
        "id": "IAB17-20",
        "iabCode": "IAB17-20",
        "name": "Боевые искусства",
        "nameEn": "Martial Arts",
        "audience": 1801688
      },
{
        "id": "IAB17-21",
        "iabCode": "IAB17-21",
        "name": "Катание на горных велосипедах",
        "nameEn": "Mountain Biking",
        "audience": 900444
      },
{
        "id": "IAB17-22",
        "iabCode": "IAB17-22",
        "name": "Гонки NASCAR",
        "nameEn": "NASCAR Racing",
        "audience": 598201
      },
{
        "id": "IAB17-23",
        "iabCode": "IAB17-23",
        "name": "Олимпийские игры",
        "nameEn": "Olympics",
        "audience": 1500227
      },
{
        "id": "IAB17-24",
        "iabCode": "IAB17-24",
        "name": "Пейнтбол",
        "nameEn": "Paintball",
        "audience": 412883
      },
{
        "id": "IAB17-25",
        "iabCode": "IAB17-25",
        "name": "Энергетика и мотоциклы",
        "nameEn": "Power & Motorcycles",
        "audience": 802389
      },
{
        "id": "IAB17-26",
        "iabCode": "IAB17-26",
        "name": "Профессиональный баскетбол",
        "nameEn": "Pro Basketball",
        "audience": 802441
      },
{
        "id": "IAB17-27",
        "iabCode": "IAB17-27",
        "name": "Профессиональный хоккей на льду",
        "nameEn": "Pro Ice Hockey",
        "audience": 709833
      },
{
        "id": "IAB17-28",
        "iabCode": "IAB17-28",
        "name": "Родео",
        "nameEn": "Rodeo",
        "audience": 299001
      },
{
        "id": "IAB17-29",
        "iabCode": "IAB17-29",
        "name": "Регби",
        "nameEn": "Rugby",
        "audience": 404937
      },
{
        "id": "IAB17-30",
        "iabCode": "IAB17-30",
        "name": "Бег/пробежка трусцой",
        "nameEn": "Running/Jogging",
        "audience": 2100559
      },
{
        "id": "IAB17-31",
        "iabCode": "IAB17-31",
        "name": "Парусный спорт",
        "nameEn": "Sailing",
        "audience": 609331
      },
{
        "id": "IAB17-32",
        "iabCode": "IAB17-32",
        "name": "Рыбалка в морской воде",
        "nameEn": "Saltwater Fishing",
        "audience": 500134
      },
{
        "id": "IAB17-33",
        "iabCode": "IAB17-33",
        "name": "подводное плавание с аквалангом",
        "nameEn": "Scuba Diving",
        "audience": 609322
      },
{
        "id": "IAB17-34",
        "iabCode": "IAB17-34",
        "name": "Скейтбординг",
        "nameEn": "Skateboarding",
        "audience": 399215
      },
{
        "id": "IAB17-35",
        "iabCode": "IAB17-35",
        "name": "Катание на лыжах",
        "nameEn": "Skiing",
        "audience": 910243
      },
{
        "id": "IAB17-36",
        "iabCode": "IAB17-36",
        "name": "Сноубординг",
        "nameEn": "Snowboarding",
        "audience": 702550
      },
{
        "id": "IAB17-37",
        "iabCode": "IAB17-37",
        "name": "Серфинг/Бодибординг",
        "nameEn": "Surfing/Bodyboarding",
        "audience": 497991
      },
{
        "id": "IAB17-38",
        "iabCode": "IAB17-38",
        "name": "Плавание",
        "nameEn": "Swimming",
        "audience": 1309883
      },
{
        "id": "IAB17-39",
        "iabCode": "IAB17-39",
        "name": "Настольный теннис/Пинг-понг",
        "nameEn": "Table Tennis/Ping-Pong",
        "audience": 298779
      },
{
        "id": "IAB17-40",
        "iabCode": "IAB17-40",
        "name": "Теннис",
        "nameEn": "Tennis",
        "audience": 1413562
      },
{
        "id": "IAB17-41",
        "iabCode": "IAB17-41",
        "name": "Волейбол",
        "nameEn": "Volleyball",
        "audience": 809427
      },
{
        "id": "IAB17-42",
        "iabCode": "IAB17-42",
        "name": "Ходьба",
        "nameEn": "Walking",
        "audience": 500333
      },
{
        "id": "IAB17-43",
        "iabCode": "IAB17-43",
        "name": "Водные лыжи/вейкборд",
        "nameEn": "Waterski/Wakeboard",
        "audience": 401923
      },
{
        "id": "IAB17-44",
        "iabCode": "IAB17-44",
        "name": "Мировой футбол",
        "nameEn": "World Soccer",
        "audience": 3500623
      }
    ]
  },
{
    "id": "IAB19",
    "iabCode": "IAB19",
    "name": "Технологии и вычисления",
    "nameEn": "Technology & Computing",
    "audience": 45104973,
    "children": [
{
        "id": "IAB19-1",
        "iabCode": "IAB19-1",
        "name": "3-D графика",
        "nameEn": "3-D Graphics",
        "audience": 1212550
      },
{
        "id": "IAB19-2",
        "iabCode": "IAB19-2",
        "name": "Анимация",
        "nameEn": "Animation",
        "audience": 901473
      },
{
        "id": "IAB19-3",
        "iabCode": "IAB19-3",
        "name": "Антивирусное программное обеспечение",
        "nameEn": "Antivirus Software",
        "audience": 2105390
      },
{
        "id": "IAB19-4",
        "iabCode": "IAB19-4",
        "name": "С/C++",
        "nameEn": "C/C++",
        "audience": 803845
      },
{
        "id": "IAB19-5",
        "iabCode": "IAB19-5",
        "name": "Фотоаппараты и видеокамеры",
        "nameEn": "Cameras & Camcorders",
        "audience": 1402442
      },
{
        "id": "IAB19-6",
        "iabCode": "IAB19-6",
        "name": "Сотовые телефоны",
        "nameEn": "Cell Phones",
        "audience": 4298429
      },
{
        "id": "IAB19-7",
        "iabCode": "IAB19-7",
        "name": "Компьютерная сертификация",
        "nameEn": "Computer Certification",
        "audience": 598734
      },
{
        "id": "IAB19-8",
        "iabCode": "IAB19-8",
        "name": "Компьютерные сети",
        "nameEn": "Computer Networking",
        "audience": 1799436
      },
{
        "id": "IAB19-9",
        "iabCode": "IAB19-9",
        "name": "Компьютерная периферия",
        "nameEn": "Computer Peripherals",
        "audience": 1104638
      },
{
        "id": "IAB19-10",
        "iabCode": "IAB19-10",
        "name": "Обзоры компьютеров",
        "nameEn": "Computer Reviews",
        "audience": 905682
      },
{
        "id": "IAB19-11",
        "iabCode": "IAB19-11",
        "name": "Центры обработки данных",
        "nameEn": "Data Centers",
        "audience": 704623
      },
{
        "id": "IAB19-12",
        "iabCode": "IAB19-12",
        "name": "Базы данных",
        "nameEn": "Databases",
        "audience": 1200553
      },
{
        "id": "IAB19-14",
        "iabCode": "IAB19-14",
        "name": "Видео на рабочем столе",
        "nameEn": "Desktop Video",
        "audience": 390502
      },
{
        "id": "IAB19-15",
        "iabCode": "IAB19-15",
        "name": "Электронная почта",
        "nameEn": "Email",
        "audience": 2309389
      },
{
        "id": "IAB19-16",
        "iabCode": "IAB19-16",
        "name": "Графическое программное обеспечение",
        "nameEn": "Graphics Software",
        "audience": 1603500
      },
{
        "id": "IAB19-17",
        "iabCode": "IAB19-17",
        "name": "Домашнее видео/DVD",
        "nameEn": "Home Video/DVD",
        "audience": 600432
      },
{
        "id": "IAB19-18",
        "iabCode": "IAB19-18",
        "name": "Интернет-технологии",
        "nameEn": "Internet Technology",
        "audience": 2515329
      },
{
        "id": "IAB19-19",
        "iabCode": "IAB19-19",
        "name": "Java",
        "nameEn": "Java",
        "audience": 1040749
      },
{
        "id": "IAB19-20",
        "iabCode": "IAB19-20",
        "name": "JavaScript",
        "nameEn": "JavaScript",
        "audience": 1355083
      },
{
        "id": "IAB19-21",
        "iabCode": "IAB19-21",
        "name": "Поддержка Mac",
        "nameEn": "Mac Support",
        "audience": 902358
      },
{
        "id": "IAB19-22",
        "iabCode": "IAB19-22",
        "name": "MP3/MIDI",
        "nameEn": "MP3/MIDI",
        "audience": 1100442
      },
{
        "id": "IAB19-23",
        "iabCode": "IAB19-23",
        "name": "Сетевая конференц-связь",
        "nameEn": "Net Conferencing",
        "audience": 698324
      },
{
        "id": "IAB19-24",
        "iabCode": "IAB19-24",
        "name": "Интернет для начинающих",
        "nameEn": "Net for Beginners",
        "audience": 1509814
      },
{
        "id": "IAB19-25",
        "iabCode": "IAB19-25",
        "name": "Информационная и сетевая безопасность",
        "nameEn": "Network Security",
        "audience": 2200289
      },
{
        "id": "IAB19-26",
        "iabCode": "IAB19-26",
        "name": "Портативные компьютеры/КПК",
        "nameEn": "Palmtops/PDAs",
        "audience": 401882
      },
{
        "id": "IAB19-27",
        "iabCode": "IAB19-27",
        "name": "Поддержка ПК",
        "nameEn": "PC Support",
        "audience": 1904687
      },
{
        "id": "IAB19-28",
        "iabCode": "IAB19-28",
        "name": "Портативный",
        "nameEn": "Portable",
        "audience": 800124
      },
{
        "id": "IAB19-29",
        "iabCode": "IAB19-29",
        "name": "Развлечение",
        "nameEn": "Entertainment",
        "audience": 2100569
      },
{
        "id": "IAB19-31",
        "iabCode": "IAB19-31",
        "name": "Unix-сервер",
        "nameEn": "Unix",
        "audience": 312801
      },
{
        "id": "IAB19-32",
        "iabCode": "IAB19-32",
        "name": "Визуальный бейсик",
        "nameEn": "Visual Basic",
        "audience": 503653
      },
{
        "id": "IAB19-34",
        "iabCode": "IAB19-34",
        "name": "Веб-дизайн/HTML",
        "nameEn": "Web Design/HTML",
        "audience": 1398333
      },
{
        "id": "IAB19-35",
        "iabCode": "IAB19-35",
        "name": "Веб-поиск",
        "nameEn": "Web Search",
        "audience": 1598335
      },
{
        "id": "IAB19-36",
        "iabCode": "IAB19-36",
        "name": "Windows",
        "nameEn": "Windows",
        "audience": 2820583
      },
{
        "id": "IAB19-30",
        "iabCode": "IAB19-30",
        "name": "Nintendo eShop"
      },
{
        "id": "IAB19-33",
        "iabCode": "IAB19-33",
        "name": "Внутриигровые покупки"
      },
{
        "id": "IAB19-37",
        "iabCode": "IAB19-37",
        "name": "SaaS-подписки"
      },
{
        "id": "IAB19-38",
        "iabCode": "IAB19-38",
        "name": "Онлайн-кинотеатры"
      },
{
        "id": "IAB19-39",
        "iabCode": "IAB19-39",
        "name": "Музыкальные подписки"
      },
{
        "id": "IAB19-40",
        "iabCode": "IAB19-40",
        "name": "Компьютерные игры"
      },
{
        "id": "IAB19-41",
        "iabCode": "IAB19-41",
        "name": "Консольные игры"
      },
{
        "id": "IAB19-42",
        "iabCode": "IAB19-42",
        "name": "Мобильные игры"
      },
{
        "id": "IAB19-43",
        "iabCode": "IAB19-43",
        "name": "Игровые подписки"
      },
{
        "id": "IAB19-44",
        "iabCode": "IAB19-44",
        "name": "Steam Wallet"
      },
{
        "id": "IAB19-45",
        "iabCode": "IAB19-45",
        "name": "PlayStation Store"
      },
{
        "id": "IAB19-46",
        "iabCode": "IAB19-46",
        "name": "Xbox Store"
      },
{
        "id": "IAB19-47",
        "iabCode": "IAB19-47",
        "name": "Игровая валюта"
      },
{
        "id": "IAB19-48",
        "iabCode": "IAB19-48",
        "name": "DLC и дополнения"
      },
{
        "id": "IAB19-49",
        "iabCode": "IAB19-49",
        "name": "Антивирусы"
      },
{
        "id": "IAB19-50",
        "iabCode": "IAB19-50",
        "name": "VPN-сервисы"
      },
{
        "id": "IAB19-51",
        "iabCode": "IAB19-51",
        "name": "Облачные сервисы"
      }
    ]
  },
{
    "id": "IAB20",
    "iabCode": "IAB20",
    "name": "Путешествия",
    "nameEn": "Travel",
    "audience": 28142006,
    "children": [
{
        "id": "IAB20-1",
        "iabCode": "IAB20-1",
        "name": "Приключенческие путешествия",
        "nameEn": "Adventure Travel",
        "audience": 1804667
      },
{
        "id": "IAB20-2",
        "iabCode": "IAB20-2",
        "name": "Африка",
        "nameEn": "Africa",
        "audience": 605329
      },
{
        "id": "IAB20-3",
        "iabCode": "IAB20-3",
        "name": "Авиапутешествия",
        "nameEn": "Air Travel",
        "audience": 2210423
      },
{
        "id": "IAB20-4",
        "iabCode": "IAB20-4",
        "name": "Австралия и Новая Зеландия",
        "nameEn": "Australia & New Zealand",
        "audience": 478208
      },
{
        "id": "IAB20-5",
        "iabCode": "IAB20-5",
        "name": "Отель типа постель и завтрак",
        "nameEn": "Bed & Breakfasts",
        "audience": 703661
      },
{
        "id": "IAB20-6",
        "iabCode": "IAB20-6",
        "name": "Бюджетные путешествия",
        "nameEn": "Budget Travel",
        "audience": 2117994
      },
{
        "id": "IAB20-7",
        "iabCode": "IAB20-7",
        "name": "Деловые поездки",
        "nameEn": "Business Travel",
        "audience": 1600328
      },
{
        "id": "IAB20-9",
        "iabCode": "IAB20-9",
        "name": "Кемпинг",
        "nameEn": "Camping",
        "audience": 1403006
      },
{
        "id": "IAB20-10",
        "iabCode": "IAB20-10",
        "name": "Канада",
        "nameEn": "Canada",
        "audience": 602567
      },
{
        "id": "IAB20-11",
        "iabCode": "IAB20-11",
        "name": "Карибы",
        "nameEn": "Caribbean",
        "audience": 823005
      },
{
        "id": "IAB20-12",
        "iabCode": "IAB20-12",
        "name": "Круизы",
        "nameEn": "Cruises",
        "audience": 1903552
      },
{
        "id": "IAB20-13",
        "iabCode": "IAB20-13",
        "name": "Восточная Европа",
        "nameEn": "Eastern Europe",
        "audience": 500033
      },
{
        "id": "IAB20-14",
        "iabCode": "IAB20-14",
        "name": "Европа",
        "nameEn": "Europe",
        "audience": 1750323
      },
{
        "id": "IAB20-15",
        "iabCode": "IAB20-15",
        "name": "Франция",
        "nameEn": "France",
        "audience": 602638
      },
{
        "id": "IAB20-16",
        "iabCode": "IAB20-16",
        "name": "Греция",
        "nameEn": "Greece",
        "audience": 409235
      },
{
        "id": "IAB20-17",
        "iabCode": "IAB20-17",
        "name": "Медовый месяц/Отпуск",
        "nameEn": "Honeymoons/Getaways",
        "audience": 908352
      },
{
        "id": "IAB20-18",
        "iabCode": "IAB20-18",
        "name": "Отели",
        "nameEn": "Hotels",
        "audience": 2406552
      },
{
        "id": "IAB20-19",
        "iabCode": "IAB20-19",
        "name": "Италия",
        "nameEn": "Italy",
        "audience": 500236
      },
{
        "id": "IAB20-20",
        "iabCode": "IAB20-20",
        "name": "Япония",
        "nameEn": "Japan",
        "audience": 592362
      },
{
        "id": "IAB20-21",
        "iabCode": "IAB20-21",
        "name": "Мексика и Центральная Америка",
        "nameEn": "Mexico & Central America",
        "audience": 698205
      },
{
        "id": "IAB20-22",
        "iabCode": "IAB20-22",
        "name": "Национальные парки",
        "nameEn": "National Parks",
        "audience": 1104624
      },
{
        "id": "IAB20-23",
        "iabCode": "IAB20-23",
        "name": "Южная Америка",
        "nameEn": "South America",
        "audience": 602363
      },
{
        "id": "IAB20-24",
        "iabCode": "IAB20-24",
        "name": "Курорты",
        "nameEn": "Spas",
        "audience": 903636
      },
{
        "id": "IAB20-25",
        "iabCode": "IAB20-25",
        "name": "Тематические парки",
        "nameEn": "Theme Parks",
        "audience": 1205683
      },
{
        "id": "IAB20-26",
        "iabCode": "IAB20-26",
        "name": "Путешествуете с детьми",
        "nameEn": "Traveling with Kids",
        "audience": 1003566
      },
{
        "id": "IAB20-27",
        "iabCode": "IAB20-27",
        "name": "Объединенное Королевство",
        "nameEn": "United Kingdom",
        "audience": 701458
      },
{
        "id": "IAB20-28",
        "iabCode": "IAB20-28",
        "name": "Хостелы"
      },
{
        "id": "IAB20-29",
        "iabCode": "IAB20-29",
        "name": "Бизнес-класс"
      },
{
        "id": "IAB20-30",
        "iabCode": "IAB20-30",
        "name": "Аренда автомобилей"
      },
{
        "id": "IAB20-31",
        "iabCode": "IAB20-31",
        "name": "Туристическое страхование"
      },
{
        "id": "IAB20-32",
        "iabCode": "IAB20-32",
        "name": "Экскурсии"
      },
{
        "id": "IAB20-33",
        "iabCode": "IAB20-33",
        "name": "Авиабилеты"
      },
{
        "id": "IAB20-34",
        "iabCode": "IAB20-34",
        "name": "Апартаменты"
      },
{
        "id": "IAB20-35",
        "iabCode": "IAB20-35",
        "name": "Туры"
      },
{
        "id": "IAB20-36",
        "iabCode": "IAB20-36",
        "name": "Пакетные туры"
      },
{
        "id": "IAB20-37",
        "iabCode": "IAB20-37",
        "name": "Премиальные путешествия"
      },
{
        "id": "IAB20-38",
        "iabCode": "IAB20-38",
        "name": "Железнодорожные билеты"
      },
{
        "id": "IAB20-39",
        "iabCode": "IAB20-39",
        "name": "Автобусные билеты"
      },
{
        "id": "IAB20-40",
        "iabCode": "IAB20-40",
        "name": "Кемпинги"
      }
    ]
  },
{
    "id": "IAB21",
    "iabCode": "IAB21",
    "name": "Недвижимость",
    "nameEn": "Real Estate",
    "audience": 5015944,
    "children": [
{
        "id": "IAB21-1",
        "iabCode": "IAB21-1",
        "name": "Квартиры",
        "nameEn": "Apartments",
        "audience": 1104677
      },
{
        "id": "IAB21-2",
        "iabCode": "IAB21-2",
        "name": "Архитекторы",
        "nameEn": "Architects",
        "audience": 704274
      },
{
        "id": "IAB21-3",
        "iabCode": "IAB21-3",
        "name": "Покупка/продажа домов",
        "nameEn": "Buying/Selling Homes",
        "audience": 3206993
      }
    ]
  },
{
    "id": "IAB22",
    "iabCode": "IAB22",
    "name": "Покупки",
    "nameEn": "Shopping",
    "audience": 3396648,
    "children": [
{
        "id": "IAB22-1",
        "iabCode": "IAB22-1",
        "name": "Конкурсы и бесплатные призы",
        "nameEn": "Contests & Freebies",
        "audience": 893502
      },
{
        "id": "IAB22-2",
        "iabCode": "IAB22-2",
        "name": "Купоны",
        "nameEn": "Couponing",
        "audience": 1193590
      },
{
        "id": "IAB22-3",
        "iabCode": "IAB22-3",
        "name": "Сравнение",
        "nameEn": "Comparison",
        "audience": 1309556
      },
{
        "id": "IAB22-4",
        "iabCode": "IAB22-4",
        "name": "Покупатели смартфонов",
        "audience": 1309556
      },
{
        "id": "IAB22-5",
        "iabCode": "IAB22-5",
        "name": "Покупатели iPhone",
        "audience": 1309556
      },
{
        "id": "IAB22-6",
        "iabCode": "IAB22-6",
        "name": "Покупатели Android-смартфонов",
        "audience": 1309556
      },
{
        "id": "IAB22-7",
        "iabCode": "IAB22-7",
        "name": "Покупатели ноутбуков",
        "audience": 1309556
      },
{
        "id": "IAB22-8",
        "iabCode": "IAB22-8",
        "name": "Покупатели игровых ноутбуков",
        "audience": 1309556
      },
{
        "id": "IAB22-9",
        "iabCode": "IAB22-9",
        "name": "Покупатели планшетов",
        "audience": 1309556
      },
{
        "id": "IAB22-10",
        "iabCode": "IAB22-10",
        "name": "Покупатели умных часов",
        "audience": 1309556
      },
{
        "id": "IAB22-11",
        "iabCode": "IAB22-11",
        "name": "Покупатели наушников",
        "audience": 1309556
      },
{
        "id": "IAB22-12",
        "iabCode": "IAB22-12",
        "name": "Покупатели телевизоров",
        "audience": 1309556
      },
{
        "id": "IAB22-13",
        "iabCode": "IAB22-13",
        "name": "Покупатели Smart TV",
        "audience": 1309556
      },
{
        "id": "IAB22-14",
        "iabCode": "IAB22-14",
        "name": "Покупатели фотоаппаратов",
        "audience": 1309556
      },
{
        "id": "IAB22-15",
        "iabCode": "IAB22-15",
        "name": "Покупатели дронов",
        "audience": 1309556
      },
{
        "id": "IAB22-16",
        "iabCode": "IAB22-16",
        "name": "Покупатели игровых консолей",
        "audience": 1309556
      },
{
        "id": "IAB22-17",
        "iabCode": "IAB22-17",
        "name": "Покупатели бытовой электроник",
        "audience": 1309556
      },
{
        "id": "IAB22-18",
        "iabCode": "IAB22-18",
        "name": "Покупатели игровых ПК",
        "audience": 1309556
      },
{
        "id": "IAB22-19",
        "iabCode": "IAB22-19",
        "name": "Покупатели видеокарт",
        "audience": 1309556
      },
{
        "id": "IAB22-20",
        "iabCode": "IAB22-20",
        "name": "Покупатели процессоров",
        "audience": 1309556
      },
{
        "id": "IAB22-21",
        "iabCode": "IAB22-21",
        "name": "Покупатели SSD",
        "audience": 1309556
      },
{
        "id": "IAB22-22",
        "iabCode": "IAB22-22",
        "name": "Покупатели мониторов",
        "audience": 1309556
      },
{
        "id": "IAB22-23",
        "iabCode": "IAB22-23",
        "name": "Покупатели игровых аксессуаров",
        "audience": 1309556
      },
{
        "id": "IAB22-24",
        "iabCode": "IAB22-24",
        "name": "Покупатели периферии",
        "audience": 1309556
      },
{
        "id": "IAB22-25",
        "iabCode": "IAB22-25",
        "name": "Покупатели сетевого оборудования",
        "audience": 1309556
      },
{
        "id": "IAB22-26",
        "iabCode": "IAB22-26",
        "name": "Покупатели мебели",
        "audience": 1309556
      },
{
        "id": "IAB22-27",
        "iabCode": "IAB22-27",
        "name": "Покупатели диванов",
        "audience": 1309556
      },
{
        "id": "IAB22-28",
        "iabCode": "IAB22-28",
        "name": "Покупатели матрасов",
        "audience": 1309556
      },
{
        "id": "IAB22-29",
        "iabCode": "IAB22-29",
        "name": "Покупатели бытовой техники",
        "audience": 1309556
      },
{
        "id": "IAB22-30",
        "iabCode": "IAB22-30",
        "name": "Покупатели холодильников",
        "audience": 1309556
      },
{
        "id": "IAB22-31",
        "iabCode": "IAB22-31",
        "name": "Покупатели стиральных машин",
        "audience": 1309556
      },
{
        "id": "IAB22-32",
        "iabCode": "IAB22-32",
        "name": "Покупатели кондиционеров",
        "audience": 1309556
      },
{
        "id": "IAB22-33",
        "iabCode": "IAB22-33",
        "name": "Покупатели роботов-пылесосов",
        "audience": 1309556
      },
{
        "id": "IAB22-34",
        "iabCode": "IAB22-34",
        "name": "Покупатели кухонной техники",
        "audience": 1309556
      },
{
        "id": "IAB22-35",
        "iabCode": "IAB22-35",
        "name": "Покупатели товаров для ремонта",
        "audience": 1309556
      },
{
        "id": "IAB22-36",
        "iabCode": "IAB22-36",
        "name": "Покупатели строительных материалов",
        "audience": 1309556
      },
{
        "id": "IAB22-37",
        "iabCode": "IAB22-37",
        "name": "Покупатели инструментов",
        "audience": 1309556
      },
{
        "id": "IAB22-38",
        "iabCode": "IAB22-38",
        "name": "Покупатели товаров для дачи",
        "audience": 1309556
      },
{
        "id": "IAB22-39",
        "iabCode": "IAB22-39",
        "name": "Покупатели женской одежды",
        "audience": 1309556
      },
{
        "id": "IAB22-40",
        "iabCode": "IAB22-40",
        "name": "Покупатели мужской одежды",
        "audience": 1309556
      },
{
        "id": "IAB22-41",
        "iabCode": "IAB22-41",
        "name": "Покупатели детской одежды",
        "audience": 1309556
      },
{
        "id": "IAB22-42",
        "iabCode": "IAB22-42",
        "name": "Покупатели спортивной одежды",
        "audience": 1309556
      },
{
        "id": "IAB22-43",
        "iabCode": "IAB22-43",
        "name": "Покупатели кроссовок",
        "audience": 1309556
      },
{
        "id": "IAB22-44",
        "iabCode": "IAB22-44",
        "name": "Покупатели обуви",
        "audience": 1309556
      },
{
        "id": "IAB22-45",
        "iabCode": "IAB22-45",
        "name": "Покупатели сумок",
        "audience": 1309556
      },
{
        "id": "IAB22-46",
        "iabCode": "IAB22-46",
        "name": "Покупатели аксессуаров",
        "audience": 1309556
      },
{
        "id": "IAB22-47",
        "iabCode": "IAB22-47",
        "name": "Покупатели ювелирных изделий",
        "audience": 1309556
      },
{
        "id": "IAB22-48",
        "iabCode": "IAB22-48",
        "name": "Покупатели часов",
        "audience": 1309556
      },
{
        "id": "IAB22-49",
        "iabCode": "IAB22-49",
        "name": "Покупатели люксовой одежды",
        "audience": 1309556
      },
{
        "id": "IAB22-50",
        "iabCode": "IAB22-50",
        "name": "Покупатели косметики",
        "audience": 1309556
      },
{
        "id": "IAB22-51",
        "iabCode": "IAB22-51",
        "name": "Покупатели средств по уходу за кожей",
        "audience": 1309556
      },
{
        "id": "IAB22-52",
        "iabCode": "IAB22-52",
        "name": "Покупатели парфюмерии",
        "audience": 1309556
      },
{
        "id": "IAB22-53",
        "iabCode": "IAB22-53",
        "name": "Покупатели средств по уходу за волосами",
        "audience": 1309556
      },
{
        "id": "IAB22-54",
        "iabCode": "IAB22-54",
        "name": "Покупатели БАДов",
        "audience": 1309556
      },
{
        "id": "IAB22-55",
        "iabCode": "IAB22-55",
        "name": "Покупатели витаминов",
        "audience": 1309556
      },
{
        "id": "IAB22-56",
        "iabCode": "IAB22-56",
        "name": "Покупатели спортивного питания",
        "audience": 1309556
      },
{
        "id": "IAB22-57",
        "iabCode": "IAB22-57",
        "name": "Покупатели медицинских товаров",
        "audience": 1309556
      },
{
        "id": "IAB22-58",
        "iabCode": "IAB22-58",
        "name": "Покупатели подгузников",
        "audience": 1309556
      },
{
        "id": "IAB22-59",
        "iabCode": "IAB22-59",
        "name": "Покупатели детского питания",
        "audience": 1309556
      },
{
        "id": "IAB22-60",
        "iabCode": "IAB22-60",
        "name": "Покупатели игрушек",
        "audience": 1309556
      },
{
        "id": "IAB22-61",
        "iabCode": "IAB22-61",
        "name": "Покупатели конструкторов",
        "audience": 1309556
      },
{
        "id": "IAB22-62",
        "iabCode": "IAB22-62",
        "name": "Покупатели школьных товаров",
        "audience": 1309556
      },
{
        "id": "IAB22-63",
        "iabCode": "IAB22-63",
        "name": "Покупатели детской мебели",
        "audience": 1309556
      },
{
        "id": "IAB22-64",
        "iabCode": "IAB22-64",
        "name": "Покупатели товаров для новорожденных",
        "audience": 1309556
      },
{
        "id": "IAB22-65",
        "iabCode": "IAB22-65",
        "name": "Покупатели продуктов онлайн",
        "audience": 1309556
      },
{
        "id": "IAB22-66",
        "iabCode": "IAB22-66",
        "name": "Пользователи сервисов доставки еды",
        "audience": 1309556
      },
{
        "id": "IAB22-67",
        "iabCode": "IAB22-67",
        "name": "Покупатели органических продуктов",
        "audience": 1309556
      },
{
        "id": "IAB22-68",
        "iabCode": "IAB22-68",
        "name": "Покупатели фермерских продуктов",
        "audience": 1309556
      },
{
        "id": "IAB22-69",
        "iabCode": "IAB22-69",
        "name": "Покупатели кофе",
        "audience": 1309556
      },
{
        "id": "IAB22-70",
        "iabCode": "IAB22-70",
        "name": "Покупатели чая",
        "audience": 1309556
      },
{
        "id": "IAB22-71",
        "iabCode": "IAB22-71",
        "name": "Покупатели готовой еды",
        "audience": 1309556
      },
{
        "id": "IAB22-72",
        "iabCode": "IAB22-72",
        "name": "Покупатели здорового питания",
        "audience": 1309556
      },
{
        "id": "IAB22-73",
        "iabCode": "IAB22-73",
        "name": "Покупатели веганских продуктов",
        "audience": 1309556
      },
{
        "id": "IAB22-74",
        "iabCode": "IAB22-74",
        "name": "Закупщики малого бизнеса",
        "audience": 1309556
      },
{
        "id": "IAB22-75",
        "iabCode": "IAB22-75",
        "name": "Закупщики среднего бизнеса",
        "audience": 1309556
      },
{
        "id": "IAB22-76",
        "iabCode": "IAB22-76",
        "name": "Корпоративные закупщики",
        "audience": 1309556
      },
{
        "id": "IAB22-77",
        "iabCode": "IAB22-77",
        "name": "Покупатели SaaS",
        "audience": 1309556
      },
{
        "id": "IAB22-78",
        "iabCode": "IAB22-78",
        "name": "Покупатели CRM",
        "audience": 1309556
      },
{
        "id": "IAB22-79",
        "iabCode": "IAB22-79",
        "name": "Покупатели ERP",
        "audience": 1309556
      },
{
        "id": "IAB22-80",
        "iabCode": "IAB22-80",
        "name": "Покупатели облачной инфраструктуры",
        "audience": 1309556
      },
{
        "id": "IAB22-81",
        "iabCode": "IAB22-81",
        "name": "Покупатели услуг кибербезопасности",
        "audience": 1309556
      },
{
        "id": "IAB22-82",
        "iabCode": "IAB22-82",
        "name": "Покупатели маркетинговых сервисов",
        "audience": 1309556
      },
{
        "id": "IAB22-83",
        "iabCode": "IAB22-83",
        "name": "Покупатели HR-решений",
        "audience": 1309556
      },
{
        "id": "IAB22-84",
        "iabCode": "IAB22-84",
        "name": "Покупатели офисного оборудования",
        "audience": 1309556
      },
{
        "id": "IAB22-85",
        "iabCode": "IAB22-85",
        "name": "Покупатели люксовых брендов",
        "audience": 1309556
      },
{
        "id": "IAB22-86",
        "iabCode": "IAB22-86",
        "name": "Покупатели премиальной электроники",
        "audience": 1309556
      },
{
        "id": "IAB22-87",
        "iabCode": "IAB22-87",
        "name": "Покупатели дизайнерской одежды",
        "audience": 1309556
      },
{
        "id": "IAB22-88",
        "iabCode": "IAB22-88",
        "name": "Покупатели премиальных автомобилей",
        "audience": 1309556
      },
{
        "id": "IAB22-89",
        "iabCode": "IAB22-89",
        "name": "Покупатели элитной недвижимости",
        "audience": 1309556
      },
{
        "id": "IAB22-90",
        "iabCode": "IAB22-90",
        "name": "Покупатели бизнес-класса",
        "audience": 1309556
      },
{
        "id": "IAB22-91",
        "iabCode": "IAB22-91",
        "name": "Покупатели премиальных путешествий",
        "audience": 1309556
      },
{
        "id": "IAB22-92",
        "iabCode": "IAB22-92",
        "name": "Покупатели люксовых часов",
        "audience": 1309556
      }
    ]
  }
];

export function expandSegmentInterests(selected) {
  if (!Array.isArray(selected) || selected.length === 0) {
    return selected || [];
  }
  const result = new Set(selected);
  SEGMENTS_MAIN.forEach((parent) => {
    if (!result.has(parent.iabCode)) {
      return;
    }
    (parent.children || []).forEach((child) => {
      result.add(child.iabCode);
    });
  });
  return [...result];
}
